// extracted by mini-css-extract-plugin
export default {"line":"DualLineCell_line__nNsVo","placeHolderShimmer":"DualLineCell_placeHolderShimmer__USNnE"};